import { Script } from '@libs/ui/ds'
import { ZENDESK_APP_ID } from '@libs/utils/environments'

import { hideZendeskWidget } from './zendesk.utils'

export const ZendeskHelperMenu = () => {
  return (
    <Script
      id='ze-snippet'
      src={`https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_APP_ID}`}
      onLoad={() => {
        /**
         * Upon script load, the Zendesk widget is hidden
         * A modal containing the Zendesk widget will be accessible via the custom bottom-left user-menu
         */
        hideZendeskWidget()
      }}
    />
  )
}
